// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nZ7v","label":"styles_label__1F9CL"};